import type { PopoverProps } from 'antd';
import { Popover } from 'antd';
import type { TooltipPlacement } from 'antd/es/tooltip';
import classNames from 'classnames';

import styles from './index.less';

interface IProps extends PopoverProps {
  className?: string;
  show?: boolean;
  arrow?: boolean;
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  open?: boolean;
  placement?: TooltipPlacement;
  overlayClassName?: string;
  destroyTooltipOnHide?: boolean;
  content?: React.ReactNode;
  titleOnly?: boolean;
}

function PAPopover(props: IProps): JSX.Element {
  const { children, show = true, overlayClassName, titleOnly, ...rest } = props;

  if (!show) {
    return <>{children}</>;
  }

  return (
    <Popover
      overlayClassName={classNames(styles.overlayClassName, overlayClassName, {
        [styles.titleOnly]: titleOnly
      })}
      {...rest}
    >
      {children}
    </Popover>
  );
}
export default PAPopover;
